(function () {
  function initCarousel(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-hero-slide]'));
    if (slides.length < 2) return;

    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-hero-dot]'));
    var prevBtn = root.querySelector('[data-hero-prev]');
    var nextBtn = root.querySelector('[data-hero-next]');
    var index = 0;
    var timer = null;
    var slideCount = slides.length;

    function goTo(i) {
      index = (i + slideCount) % slideCount;
      slides.forEach(function (slide, si) {
        slide.classList.toggle('is-active', si === index);
      });
      dots.forEach(function (dot, di) {
        dot.classList.toggle('is-active', di === index);
      });
    }

    function next() { goTo(index + 1); }
    function prev() { goTo(index - 1); }

    if (nextBtn) nextBtn.addEventListener('click', function () { next(); resetAutoplay(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); resetAutoplay(); });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.getAttribute('data-index'), 10));
        resetAutoplay();
      });
    });

    function startAutoplay() {
      var enabled = root.getAttribute('data-autoplay') === 'true';
      var speed = parseInt(root.getAttribute('data-autoplay-speed'), 10) || 6000;
      if (!enabled) return;
      timer = setInterval(next, speed);
    }

    function resetAutoplay() {
      if (timer) clearInterval(timer);
      startAutoplay();
    }

    goTo(0);
    startAutoplay();
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-hero-carousel]').forEach(initCarousel);
  });
})();
